import UAParser from "ua-parser-js";
import {v4 as uuid } from 'uuid';
import FingerPrint from 'fingerprintjs2';
import qs from 'qs';
import { toCamelCase } from "../../../../commons/utils/strings";


function getQueryParams () {
    // embedded is when loaded in iframe
    const embedded = (window !== window.parent || window !== window.top);
    const qsParams = qs.parse(window.location.search.replace('?', ''));
    let referrer = window.parent ? window.parent?.document?.referrer : document.referrer;

    const {
        docReferrer = referrer,
        // eCalapiKey, 
        // k,
        /*
        apiKey = k || eCalapiKey,
        */
        // widgetRef: ref = apiKey,
        // isPreview, locale, language = locale,
        // referrer,
        // clientOrigin,
    } = qsParams;

    // console.log('getQueryParams() eCalapiKey: -> ', eCalapiKey);
    return {
        docReferrer,
        embedded,
    };
}

function getIsWebView (ua) {
    return !!('webView' in window ||
        'ondeviceready' in window.document ||
        'Ti' in window ||
        (window.external && 'notify' in window.external) ||
        (ua.ua.indexOf(' Mobile/') > 0 && ua.ua.indexOf(' Safari/') === -1)
    );
}

export function getFlags (ua) {
    const embedded = (window !== window.parent || window !== window.top);
    const integrated = (window?.name?.includes(['app_runner_fb']));

    let docReferrer = '';
    try {
        const {
            docReferrer: dr,
        } = getQueryParams();
        docReferrer = dr; 
    } catch (err) {
        console.log('app.actions.getSpecDetails().getFlags() Doc Referrer error');
    }

    const {
        os,
        device,
        browser,
      } = ua;

      console.log('getSpecDetails() docReferrer():  ', docReferrer);
      console.log('getSpecDetails ua():  ', ua);

      const browserName = toCamelCase(browser.name.toLowerCase());
      const osName = toCamelCase(os.name.toLowerCase());
  
      const isWebview = getIsWebView(ua);
  
      const standalone = window.navigator.standalone;
      const ios = osName.includes('ios');
      const safari = browserName.toLowerCase().includes('safari');
      const desktop = !device.type;

      // please refer https://t.co/
      const isTwitter = (docReferrer && docReferrer.includes('t.co'));
      
      // console.log('getSpecDetails isTwitter():  ', isTwitter);

      // please refer linkedin.com
      let isLinkedInRef = (docReferrer && docReferrer.includes('linkedin.com'));
      if (!isLinkedInRef) {
        isLinkedInRef = (ua.ua.indexOf('LinkedInApp') !== -1);
      }
  
      const twitterInAppIOS = ios && isTwitter;
      let android = false;
      let mac = false;
      if (osName) {
        android = osName.indexOf('android') !== -1;
        mac = osName.indexOf('mac') !== -1;
      }

      const flags = {
        desktop,
        mobile: device.type === 'mobile',
        ie: browserName === 'ie',
        iemobile: browserName === 'iemobile',
        chrome: browserName === 'chrome',
        firefox: browserName === 'firefox',
        edge: browserName.includes('edge'),
        ios,
        safari,
        standalone,
        webview: isWebview,
        inAppBrowser: twitterInAppIOS || standalone || isWebview || !!(['webkit', 'facebook', 'iemobile', 'twitter'].includes(browserName.toLowerCase())),
        embedded,
        isTwitter,
        isLinkedIn: isLinkedInRef,
        deviceType: desktop ? 'desktop' : 'mobile',
        integrated,
        docReferrer,
        activeUser: false,
        android,
        osName,
        mac,
        tablet: device.type === 'tablet',
        model: device.model,
      };

      return flags;
}

function getSpecDetails () {
    const parser = new UAParser();
    const ua = parser.getResult();
    this.userAgent = ua;
    this.flags = getFlags(ua);
    // this.fingerprint = uuid();
    this.generateFingerprint();
    this.appName = this.getAppName();
    this.observed.userAgent = uuid();
}

async function getFingerprint () {
    const p = new Promise((resolve) => {
        new FingerPrint({ excludeCanvas: true }).get(data => resolve(data));
    });
    return p;
}

export async function generateFingerprint () {
    this.fingerprint = await getFingerprint();
}

export default getSpecDetails;
